import React from 'react';
import type { IconProps } from '../types';

export const OrientationSwitch = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient id="orientationGradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="currentColor" stopOpacity="0.9" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
    </defs>

    <path
      d="M213.088 253.344L59.77 170.021C52.95 166.316 44.897 166.469 38.223 170.436C31.55 174.402 27.568 181.405 27.568 189.169V382.459C27.568 390.279 31.791 397.539 38.59 401.405L191.911 488.568C195.291 490.489 198.987 491.449 202.684 491.449C206.451 491.449 210.217 490.452 213.642 488.458C220.425 484.512 224.475 477.47 224.475 469.622V272.493C224.475 264.499 220.113 257.162 213.088 253.344Z"
      stroke="url(#orientationGradient)"
      strokeWidth="28"
      strokeLinejoin="round"
    />

    <path
      d="M437.621 115.118C437.611 107.809 433.117 101.179 425.895 97.816L259.245 20.19C252.935 17.249 245.415 17.271 239.128 20.245L74.929 97.871C67.779 101.252 63.333 107.861 63.322 115.12C63.313 122.378 67.742 128.996 74.881 132.392L239.081 210.503C242.26 212.014 245.75 212.771 249.243 212.771C252.692 212.771 256.143 212.033 259.29 210.557L425.944 132.448C433.157 129.067 437.632 122.426 437.621 115.118Z"
      stroke="url(#orientationGradient)"
      strokeWidth="28"
      strokeLinejoin="round"
    />

    <path
      d="M461.568 169.452C454.865 165.465 446.767 165.308 439.915 169.034L285.814 252.781C278.755 256.618 274.371 263.992 274.371 272.026V470.155C274.371 478.043 278.441 485.121 285.259 489.088C288.701 491.091 292.486 492.093 296.273 492.093C299.988 492.093 303.704 491.128 307.1 489.199L461.2 401.594C468.034 397.709 472.277 390.412 472.277 382.552V188.28C472.277 180.477 468.275 173.439 461.568 169.452Z"
      stroke="url(#orientationGradient)"
      strokeWidth="28"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrientationSwitch;